module.exports = __webpack_public_path__ + "img/app6.9b465085.png";